import type {TrackingEvent} from 'web-app/util/famlytics/types';

export const AddPlanEvents = {
    ADD_PLAN: {
        name: 'Plan: Plan created',
        sendTo: ['Mixpanel'],
        isActive: true,
        expirationDate: 'none',
    },
    ADD_PLAN_FLOW_STARTED: {
        name: 'Plan: Create plan started (Overview)',
        sendTo: ['Mixpanel'],
        isActive: true,
        expirationDate: 'none',
    },
} satisfies Record<string, TrackingEvent>;
